import { type ThemeProps } from '@kijiji/theme'
import styled from 'styled-components'

import {
  type AttributeWithIconProps,
  type IconBackgroundVariant,
} from '@/features/attributes/components/AttributeWithIcon'
import { Flex } from '@/ui/atoms/flex'

const iconBackground = ({ colors }: ThemeProps): Record<IconBackgroundVariant, string> => ({
  'no-bg': 'none',
  'primary-bg': colors.purple.light5,
  'secondary-bg': colors.grey.light5,
})

export const AttributeWithIconWrapper = styled(Flex)(
  ({ theme }) => `
  display: flex;

  & svg {
    color: ${theme.colors.grey.primary};
    height: 3.2rem;
    width: 3.2rem;
  }
`
)

export const AttributeIconContainer = styled.div<{
  iconBackgroundVariant: NonNullable<AttributeWithIconProps['iconBackgroundVariant']>
}>(
  ({ theme, iconBackgroundVariant }) => `
  align-items: center;
  background-color: ${iconBackground(theme)[iconBackgroundVariant]};
  border-radius: ${theme.borderRadius.rounded};
  display: flex;
  height: 4rem;
  justify-content: center;
  width: 4rem;
`
)
